<template>
  <v-snackbar v-model="show" :timeout="duration" :dark="isDark" bottom>
    <v-icon :color="messageIconColor" class="mr-4">{{ messageIcon }}</v-icon>
    <!-- Using v-html to allow stylistic formatting in notification messages -->
    <span v-html="messageText"></span>
    <template v-slot:action="{ attrs }">
      <v-btn v-if="sticky" color="primary" v-bind="attrs" text @click="dismiss">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SmsNotificationToast',

  data() {
    return {
      duration: 5000,
      messageIcon: '',
      messageIconColor: '#FFF',
      messageText: '',
      show: false,
      sticky: false
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.isDark;
    }
  },

  methods: {
    /**
     * Dismisses the notification and resets component data
     */
    dismiss() {
      this.reset();
      this.show = false;
    },
    /**
     * Resets component data to default values
     */
    reset() {
      this.duration = 5000;
      this.messageIcon = '';
      this.messageIconColor = '#FFF';
      this.messageText = '';
      this.sticky = false;
    },
    /**
     * Shows the snackbar with the appropriate settings provided by
     * ToastMixin $emit method on root instance
     * @param notification
     */
    showNotification(notification) {
      const { duration, icon, iconColor, message, sticky } = notification;
      this.duration = duration;
      this.messageIcon = icon;
      this.messageIconColor = iconColor;
      this.messageText = message;
      this.sticky = sticky;
      this.show = true;
    }
  },

  mounted() {
    this.$root.$on('notify-user', this.showNotification);
  }
};
</script>

<style scoped></style>
